import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveProjectStatusRequestFailure() {
      return getState().isFailure;
    },
    isRemoveProjectStatusRequestPending() {
      return getState().isPending;
    },
    isRemoveProjectStatusRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
